<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><em><strong><a id="page_xii">Chief Abbreviations</a></strong></em></h1><a id="page_xii">
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang"><em>AB</em></p></td>
<td class="col65"><p class="t-left"><em>The Anchor Bible:</em> W. F. Albright and C. S. Mann, <em>Matthew</em> (New York, 1971)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Allen</p></td>
<td class="col65"><p class="t-left">W. C. Allen, <em>A Critical and Exegetical Commentary on the Gospel according to Matthew</em> (Edinburgh, 1907)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Argyle</p></td>
<td class="col65"><p class="t-left">A. W. Argyle, <em>The Gospel according to Matthew</em> (Cambridge, 1963)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">AS</p></td>
<td class="col65"><p class="t-left">G. Abbott-Smith, <em>A Manual Greek Lexicon of the New Testament</em> (Edinburgh, 1954)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ASV</em></p></td>
<td class="col65"><p class="t-left"><em>The American Standard Version</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Augustine</p></td>
<td class="col65"><p class="t-left">Augustine, <em>Our Lord’s Sermon on the Mount</em> (NPNF, 1st ser., vol. VI)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BAGD</p></td>
<td class="col65"><p class="t-left">Walter Bauer, <em>A Greek-English Lexicon of the New Testament and Other Early Christian Literature,</em> rev. and aug. by William F. Arndt, F. Wilbur Gingrich, and Frederick W. Danker from the 5th edn. (Chicago, 1979)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Barclay</p></td>
<td class="col65"><p class="t-left">William Barclay, <em>The Gospel of Matthew,</em> 2 vols. (Edinburgh, 1958)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">BDF</p></td>
<td class="col65"><p class="t-left">F. Blass and A. Debrunner, <em>A Greek Grammar of the New Testament,</em> trans. and rev. by R. W. Funk (Chicago, 1961)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Beare</p></td>
<td class="col65"><p class="t-left">F. W. Beare, <em>The Gospel according to Matthew</em> (San Francisco, 1981)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>BEB</em></p></td>
<td class="col65"><p class="t-left">W. A. Elwell, ed., <em>Baker Encyclopedia of the Bible</em> (Grand Rapids, 1988)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Bengel</p></td>
<td class="col65"><p class="t-left">J. A. Bengel, <em>Gnomon of the New Testament,</em> I (Edinburgh, 1866)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Black</p></td>
<td class="col65"><p class="t-left">Matthew Black, <em>An Aramaic Appoach to the Gospels and Acts</em> (Oxford, 1946)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Bonnard</p></td>
<td class="col65"><p class="t-left">P. Bonnard, <em>L’Evangile selon Saint Matthieu,</em> 2nd edn. (Neuchâtel, 1970)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Bruce</p></td>
<td class="col65"><p class="t-left"><em>The Expositor’s Greek Testament:</em> A. B. Bruce, <em>The Synoptic Gospels</em> (Grand Rapids, 1979 rpt.)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Bruner</p></td>
<td class="col65"><p class="t-left">F. D. Bruner, <em>The Christbook, Matthew 1–12</em> (Waco, 1987)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>BS</em></p></td>
<td class="col65"><p class="t-left">A. Deissmann, <em>Bible Studies</em> (Edinburgh, 1901)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Burton, <em>MT</em></p></td>
<td class="col65"><p class="t-left">E. de W. Burton: <em>Syntax of the Moods and Tenses in New Testament Greek</em> (Edinburgh, 1955)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Buttrick</p></td>
<td class="col65"><p class="t-left"><em>The Interpreter’s Bible,</em> VII: G. A. Buttrick, <em>The Gospel according to St. Matthew, Exposition</em> (Nashville, 1951)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xiii">Calvin</a></p></td>
<td class="col65"><p class="t-left">J. Calvin, <em>A Harmony of the Gospels, Matthew, Mark and Luke,</em> 3 vols. (Grand Rapids, 1980 rpt.)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Carr</p></td>
<td class="col65"><p class="t-left"><em>Cambridge Greek Testament:</em> A. Carr, <em>The Gospel according to St Matthew</em> (Cambridge, 1892)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Carson</p></td>
<td class="col65"><p class="t-left">D. A. Carson, <em>Matthew,</em> in F. E. Gaebelein, ed., <em>The Expositor’s Bible Commentary,</em> vol. 8 (Grand Rapids, 1984)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Carson, <em>SM</em></p></td>
<td class="col65"><p class="t-left">D. A. Carson, <em>The Sermon on the Mount</em> (Grand Rapids, 1982)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Cassirer</p></td>
<td class="col65"><p class="t-left">H. W. Cassirer, <em>God’s New Covenant: A New Testament Translation</em> (Grand Rapids, 1989)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Chamberlain</p></td>
<td class="col65"><p class="t-left">W. D. Chamberlain, <em>An Exegetical Grammar of the Greek New Testament</em> (New York, 1941)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Chrysostom</p></td>
<td class="col65"><p class="t-left">John Chrysostom, <em>Homilies on St. Matthew</em> (NPNF, 1st ser., vol. X)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Danby</p></td>
<td class="col65"><p class="t-left">H. Danby, <em>The Mishnah</em> (Oxford, 1933)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Daube</p></td>
<td class="col65"><p class="t-left">D. Daube, <em>The New Testament and Rabbinic Judaism</em> (London, 1956)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Davies and Allison</p></td>
<td class="col65"><p class="t-left">W. D. Davies and D. C. Allison, <em>A Critical and Exegetical Commentary on the Gospel according to Saint Matthew,</em> vol. I (Edinburgh, 1988)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>DB</em></p></td>
<td class="col65"><p class="t-left">F. C. Grant and H. H. Rowley, eds., <em>Dictionary of the Bible</em> (Edinburgh, 1963)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Derrett</p></td>
<td class="col65"><p class="t-left">J. D. M. Derrett, <em>Law in the New Testament</em> (London, 1970)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Diétrich</p></td>
<td class="col65"><p class="t-left">S. de Diétrich, <em>Saint Matthew</em> (London, 1962)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">DM</p></td>
<td class="col65"><p class="t-left">H. E. Dana and J. R. Mantey, <em>A Manual Grammar of the Greek New Testament</em> (New York, 1927)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ET</em></p></td>
<td class="col65"><p class="t-left"><em>The Expository Times</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Fenton</p></td>
<td class="col65"><p class="t-left">J. C. Fenton, <em>The Gospel of St Matthew</em> (Harmondsworth, 1963)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Filson</p></td>
<td class="col65"><p class="t-left">F. V. Filson, <em>A Commentary on the Gospel according to St.</em> <em>Matthew</em> (London, 1960)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">France</p></td>
<td class="col65"><p class="t-left">R. T. France, <em>The Gospel according to Matthew</em> (Leicester and Grand Rapids, 1985)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Glover</p></td>
<td class="col65"><p class="t-left">R. Glover, <em>A Teacher’s Commentary on the Gospel of St. Matthew</em> (London, 1956)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>GNB</em></p></td>
<td class="col65"><p class="t-left"><em>Good News Bible</em> (London and New York, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Green</p></td>
<td class="col65"><p class="t-left">H. B. Green, <em>The Gospel according to Matthew</em> (Oxford, 1975)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Green, M.</p></td>
<td class="col65"><p class="t-left">M. Green, <em>Matthew for Today</em> (London, 1988)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>GT</em></p></td>
<td class="col65"><p class="t-left"><em>A Greek-English Lexicon of the New Testament,</em> trans. J. H. Thayer (Edinburgh, 1888)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>GTJ</em></p></td>
<td class="col65"><p class="t-left"><em>Grace Theological Journal</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Grammatical Insights</em></p></td>
<td class="col65"><p class="t-left">Nigel Turner, <em>Grammatical Insights into the New Testament</em> (Edinburgh, 1965)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Gundry</p></td>
<td class="col65"><p class="t-left">R. H. Gundry, <em>Matthew</em> (Grand Rapids, 1982)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Gutzwiller</p></td>
<td class="col65"><p class="t-left">R. Gutzwiller, <em>Day by Day with Saint Matthew’s Gospel</em> (London, 1964)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Hamann</p></td>
<td class="col65"><p class="t-left">H. P. Hamann, <em>The Gospel according to Matthew</em> (Adelaide, 1984)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xiv">Hendriksen</a></p></td>
<td class="col65"><p class="t-left">W. Hendriksen, <em>New Testament Commentary: Exposition of the Gospel according to Matthew</em> (Grand Rapids, 1973)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Hill</p></td>
<td class="col65"><p class="t-left">D. Hill, <em>The Gospel of Matthew</em> (London, 1972)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Horsley</p></td>
<td class="col65"><p class="t-left">G. H. R. Horsley, <em>New Documents Illustrating Early Christianity,</em> vols. 1-5 (Sydney, 1981-89)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>IBD</em></p></td>
<td class="col65"><p class="t-left"><em>The Illustrated Bible Dictionary,</em> 3 vols. (Leicester, 1980)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>IBNTG</em></p></td>
<td class="col65"><p class="t-left">C. F. D. Moule, <em>An Idiom Book of New Testament Greek</em> (Cambridge, 1953)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ICC</em></p></td>
<td class="col65"><p class="t-left"><em>The International Critical Commentary</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>IDB</em></p></td>
<td class="col65"><p class="t-left"><em>The Interpreter’s Dictionary of the Bible,</em> 4 vols. (Nashville, 1962; supplementary volume, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ISBN</em></p></td>
<td class="col65"><p class="t-left"><em>The International Standard Bible Encyclopedia,</em> 4 vols. (Grand Rapids, 1979-88)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JB</em></p></td>
<td class="col65"><p class="t-left"><em>The Jerusalem Bible</em> (London, 1966)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JBL</em></p></td>
<td class="col65"><p class="t-left"><em>The Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Johnson</p></td>
<td class="col65"><p class="t-left"><em>The Interpreter’s Bible,</em> VII: S. E. Johnson, <em>The Gospel according to St. Matthew, Exegesis</em> (Nashville, 1951)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>JTS</em></p></td>
<td class="col65"><p class="t-left"><em>The Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Kingsbury</p></td>
<td class="col65"></td>
</tr>
<tr>
<td class="col30"><p class="t-hang1"><em>Matthew</em></p></td>
<td class="col65"><p class="t-left">J. D. Kingsbury, <em>Matthew</em> (Philadelphia, 1986)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang1"><em>Story</em></p></td>
<td class="col65"><p class="t-left">J. D. Kingsbury, <em>Matthew as Story</em> (Philadelphia, 1988)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang1"><em>Structure</em></p></td>
<td class="col65"><p class="t-left">J. D. Kingsbury, <em>Matthew: Structure, Christology, Kingdom</em> (Philadelphia, 1975)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>KJV</em></p></td>
<td class="col65"><p class="t-left"><em>The King James Version</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Knox</p></td>
<td class="col65"><p class="t-left">R. Knox, <em>The Holy Bible: A Translation from the Latin Vulgate</em> (London, 1955)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>LAE</em></p></td>
<td class="col65"><p class="t-left">A. Deissmann, <em>Light from the Ancient East</em> (London, 1927)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Law</em></p></td>
<td class="col65"><p class="t-left">J. D. M. Derrett, <em>Law in the New Testament</em> (London, 1970)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>LB</em></p></td>
<td class="col65"><p class="t-left"><em>The Living Bible</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Lenski</p></td>
<td class="col65"><p class="t-left">R. C. H. Lenski, <em>The Interpretation of St. Matthew’s Gospel</em> (Minneapolis, 1964)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>L’ÉSM</em></p></td>
<td class="col65"><p class="t-left">M. Didier, <em>L’Évangile selon Matthieu</em> (Gembloux, 1972)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Lightfoot</p></td>
<td class="col65"><p class="t-left">John Lightfoot, <em>A Commentary on the New Testament from the Talmud and Hebraica,</em> 4 vols. (Grand Rapids, 1979 rpt.)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Lloyd-Jones</p></td>
<td class="col65"><p class="t-left">D. M. Lloyd-Jones, <em>Studies in the Sermon on the Mount</em> (Grand Rapids, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">LSJ</p></td>
<td class="col65"><p class="t-left"><em>A Greek-English Lexicon,</em> comp. by H. G. Liddell and R. Scott, rev. by H. S. Jones and R. McKenzie, 2 vols. (Oxford, 1940)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">LXX</p></td>
<td class="col65"><p class="t-left">The Septuagint</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">M, I</p></td>
<td class="col65"><p class="t-left">J. H. Moulton, <em>A Grammar of New Testament Greek,</em> vol. 1, <em>Prolegomena</em> (Edinburgh, 1906)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">M, II</p></td>
<td class="col65"><p class="t-left"><em>Ibid.,</em> II, <em>Accidence and Word Formation,</em> ed. W. F. Howard (Edinburgh, 1919)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">M, III</p></td>
<td class="col65"><p class="t-left"><em>Ibid.,</em> III, <em>Syntax,</em> by Nigel Turner (Edinburgh, 1963)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">M, IV</p></td>
<td class="col65"><p class="t-left"><em>Ibid.,</em> IV, <em>Style,</em> by Nigel Turner (Edinburgh, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xv">McNeile</a></p></td>
<td class="col65"><p class="t-left">A. H. McNeile: <em>The Gospel according to St. Matthew</em> (London, 1915)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Meier</p></td>
<td class="col65"><p class="t-left">J. P. Meier, <em>Matthew</em> (Wilmington, 1980)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Melinsky</p></td>
<td class="col65"><p class="t-left">H. Melinsky, <em>Matthew</em> (London, 1965)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Metzger</p></td>
<td class="col65"><p class="t-left">B. M. Metzger, <em>A Textual Commentary on the Greek New Testament</em> (London and New York, 1971)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">MM</p></td>
<td class="col65"><p class="t-left">J. H. Moulton and G. Milligan, <em>The Vocabulary of the Greek Testament</em> (London, 1914-29)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Moore</p></td>
<td class="col65"><p class="t-left">G. F. Moore, <em>Judaism,</em> 2 vols. (Cambridge, 1958), vol. 3 (1959)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Morgan</p></td>
<td class="col65"><p class="t-left">G. C. Morgan, <em>The Gospel according to Matthew</em> (London, n.d.)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Mounce</p></td>
<td class="col65"><p class="t-left">R. H. Mounce, <em>Matthew</em> (San Francisco, 1985)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NASB</em></p></td>
<td class="col65"><p class="t-left"><em>New American Standard Bible</em> (La Habra, 1972)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NBCR</em></p></td>
<td class="col65"><p class="t-left"><em>New Bible Commentary, Revised</em> (London, 1970)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NIDNTT</em></p></td>
<td class="col65"><p class="t-left">C. Brown, ed., <em>The New International Dictionary of New Testament Theology,</em> 3 vols. (Exeter, 1975-78)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NIV</em></p></td>
<td class="col65"><p class="t-left"><em>The Holy Bible, New International Version</em> (Grand Rapids, 1978)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Nixon</p></td>
<td class="col65"><p class="t-left">R. E. Nixon, <em>Matthew,</em> in D. Guthrie, J. A. Motyer, A. M. Stibbs, and D. J. Wiseman, eds., <em>The New Bible Commentary Revised</em> (London, 1970)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">NPNF</p></td>
<td class="col65"><p class="t-left">Nicene and Post-Nicene Fathers</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NRSV</em></p></td>
<td class="col65"><p class="t-left"><em>The Holy Bible: New Revised Standard Version</em> (Nashville, 1990)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>NTS</em></p></td>
<td class="col65"><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>ODCC</em></p></td>
<td class="col65"><p class="t-left">F. L. Cross, ed., <em>The Oxford Dictionary of the Christian Church</em> (London, 1958)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>OED</em></p></td>
<td class="col65"><p class="t-left"><em>The Shorter Oxford English Dictionary,</em> 2 vols. (London, 1944; rpt. with corrections, 1959)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Patte</p></td>
<td class="col65"><p class="t-left">D. Patte, <em>The Gospel according to Matthew</em> (Philadelphia, 1987)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Phillips</p></td>
<td class="col65"><p class="t-left">J. B. Phillips, <em>The Gospels in Modern English</em> (London, 1957)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Plummer</p></td>
<td class="col65"><p class="t-left">A. Plummer, <em>An Exegetical Commentary on the Gospel according to S. Matthew</em> (London, 1910)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>REB</em></p></td>
<td class="col65"><p class="t-left"><em>The Revised English Bible</em> (Oxford and Cambridge, 1989)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Redating</em></p></td>
<td class="col65"><p class="t-left">J. A. T. Robinson, <em>Redating the New Testament</em> (London, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Ridderbos</p></td>
<td class="col65"><p class="t-left">H. N. Ridderbos, <em>Matthew</em> (Grand Rapids, 1987)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Robertson</p></td>
<td class="col65"><p class="t-left">A. T. Robertson, <em>A Grammar of the Greek New Testament in the Light of Historical Research</em> (London, n.d.)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Robinson</p></td>
<td class="col65"><p class="t-left">T. H. Robinson, <em>The Gospel of Matthew</em> (London, 1928)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>RSV</em></p></td>
<td class="col65"><p class="t-left"><em>The Revised Standard Version</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>RThR</em></p></td>
<td class="col65"><p class="t-left"><em>The Reformed Theological Review</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Ryle</p></td>
<td class="col65"><p class="t-left">J. C. Ryle, <em>Expository Thoughts on the Gospels: Matthew</em> (London, 1965)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">SBk</p></td>
<td class="col65"><p class="t-left">H. L. Strack and P. Billerbeck, <em>Kommentar zum Neuen Testament aus Talmud und Midrasch,</em> 4 vols. (Munich, 1922-28)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Schweizer</p></td>
<td class="col65"><p class="t-left">E. Schweizer, <em>The Good News according to Matthew</em> (London, 1976)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><a id="page_xvi"><em>Sermon</em></a></p></td>
<td class="col65"><p class="t-left">W. D. Davies, <em>The Sermon on the Mount</em> (Cambridge, 1966)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>SJT</em></p></td>
<td class="col65"><p class="t-left"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>SM</em></p></td>
<td class="col65"><p class="t-left">W. D. Davies, <em>The Setting of the Sermon on the Mount</em> (Cambridge, 1964)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Stanton</p></td>
<td class="col65"><p class="t-left">G. Stanton, ed., <em>The Interpretation of Matthew</em> (London and Philadelphia, 1983)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Stendahl</p></td>
<td class="col65"><p class="t-left">K. Stendahl, in <em>Peake’s Commentary on the Bible,</em> ed. M. Black and H. H. Rowley (London, 1962)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Stonehouse</p></td>
<td class="col65"></td>
</tr>
<tr>
<td class="col30"><p class="t-hang1"><em>Witness</em></p></td>
<td class="col65"><p class="t-left">N. B. Stonehouse, <em>The Witness of Matthew and Mark to Christ</em> (London, 1944)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang1"><em>Origins</em></p></td>
<td class="col65"><p class="t-left">N. B. Stonehouse, <em>Origins of the Synoptic Gospels</em> (London, 1964)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Stott</p></td>
<td class="col65"><p class="t-left">J. R. W. Stott, <em>The Message of the Sermon on the Mount</em> (Leicester, 1978)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Tasker</p></td>
<td class="col65"><p class="t-left">R. V. G. Tasker, <em>The Gospel according to St. Matthew</em> (London, 1961)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TDNT</em></p></td>
<td class="col65"><p class="t-left"><em>Theological Dictionary of the New Testament,</em> trans. G. W. Bromiley (Grand Rapids, 1964-76)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>TIM</em></p></td>
<td class="col65"><p class="t-left">G. Bornkamm, G. Barth, and H. J. Held, <em>Tradition and Interpretation in Matthew</em> (London, 1963)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Trench</p></td>
<td class="col65"><p class="t-left">R. C. Trench, <em>Synonyms of the New Testament</em> (London, 1880)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Turner</p></td>
<td class="col65"><p class="t-left">N. Turner, <em>Grammatical Insights into the New Testament</em> (Edinburgh, 1965)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">UBS<sup>3</sup></p></td>
<td class="col65"><p class="t-left">United Bible Societies’ <em>Greek New Testament,</em> eds. Kurt Aland et al., 3rd edn. (New York, 1975)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Use of the OT</em></p></td>
<td class="col65"><p class="t-left">R. H. Gundry, <em>The Use of the Old Testament in St. Matthew’s Gospel</em> (Leiden, 1975)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Vermes</p></td>
<td class="col65"><p class="t-left">G. Vermes, <em>The Dead Sea Scrolls in English</em> (Harmondsworth, 1968)</p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang">Zahn</p></td>
<td class="col65"><p class="t-left">T. Zahn, <em>Das Evangelium des Matthäus</em> (Leipzig, 1922)</p></td>
</tr>
</tbody>
</table>
<p class="fm-head">JEWISH TRACTATES</p>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-hang"><span class="char">ʿ</span><em>Abod. Zar.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">ʿ</span><em>Aboda Zara</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">ʾ</span><em>Abot</em></p></td>
<td class="col65"><p class="t-left"><span class="char">ʾ</span><em>Abot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">ʿ</span><em>Arak.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">ʿ</span><em>Arakin.</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>B. Bat.</em></p></td>
<td class="col65"><p class="t-left"><em>Baba Batra</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>B. Me</em><span class="char">ṣ</span></p></td>
<td class="col65"><p class="t-left"><em>Baba Me</em><span class="char">ṣ</span><em>i</em><span class="char">ʿ</span><em>a</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>B. Qam.</em></p></td>
<td class="col65"><p class="t-left"><em>Baba Qamma</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Bek.</em></p></td>
<td class="col65"><p class="t-left"><em>Bekorot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ber.</em></p></td>
<td class="col65"><p class="t-left"><em>Berakot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Dem.</em></p></td>
<td class="col65"><p class="t-left"><em>Demai</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">ʿ</span><em>Eduy.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">ʿ</span><em>Eduyyot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">ʿ</span><em>Erub.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">ʿ</span><em>Erubin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Gi</em><span class="char">ṭ</span><em>.</em></p></td>
<td class="col65"><p class="t-left"><em>Gi</em><span class="char">ṭ</span><span class="char">ṭ</span><em>in</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">Ḥ</span><em>ag.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">Ḥ</span><em>agiga</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">Ḥ</span><em>ul.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">Ḥ</span><em>uüin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ker.</em></p></td>
<td class="col65"><p class="t-left"><em>Keritot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ketub.</em></p></td>
<td class="col65"><p class="t-left"><em>Ketubot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ma</em><span class="char">ʿ</span><em>aś<strong>.</strong> Sh.</em></p></td>
<td class="col65"><p class="t-left"><em>Ma'aśer Sheni</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Mak.</em></p></td>
<td class="col65"><p class="t-left"><em>Makkot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Meg.</em></p></td>
<td class="col65"><p class="t-left"><em>Megilla</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ment</em><span class="char">ḥ</span><em>.</em></p></td>
<td class="col65"><p class="t-left"><em>Mena</em><span class="char">ḥ</span><em>ot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ned.</em></p></td>
<td class="col65"><p class="t-left"><em>Nedarim</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ohol.</em></p></td>
<td class="col65"><p class="t-left"><em>Oholot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Pes.</em></p></td>
<td class="col65"><p class="t-left"><em>Pesa</em><span class="char">ḥ</span><em>im</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Pesiq.</em></p></td>
<td class="col65"><p class="t-left"><em>Pesiqta Rabbati</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Qidd.</em></p></td>
<td class="col65"><p class="t-left"><em>Qiddushin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Rosh. Hash.</em></p></td>
<td class="col65"><p class="t-left"><em>Rosh. Ha-Shana</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Sanh.</em></p></td>
<td class="col65"><p class="t-left"><em>Sanhedrin</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Shab.</em></p></td>
<td class="col65"><p class="t-left"><em>Shabbat</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Shebu.</em></p></td>
<td class="col65"><p class="t-left"><em>Shebu</em><span class="char">ʿ</span><em>ot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Sheqal.</em></p></td>
<td class="col65"><p class="t-left"><em>Sheqalim</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Soṭa</em></p></td>
<td class="col65"><p class="t-left"><em>Soṭa</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Ta</em><span class="char">ʿ</span><em>an.</em></p></td>
<td class="col65"><p class="t-left"><em>Ta</em><span class="char">ʿ</span><em>anit</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><span class="char">Ṭ</span><em>ohar.</em></p></td>
<td class="col65"><p class="t-left"><span class="char">Ṭ</span><em>oharot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Yad.</em></p></td>
<td class="col65"><p class="t-left"><em>Yadaim</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Yebam.</em></p></td>
<td class="col65"><p class="t-left"><em>Yebamot</em></p></td>
</tr>
<tr>
<td class="col30"><p class="t-hang"><em>Yoma</em></p></td>
<td class="col65"><p class="t-left"><em>Yoma<a id="page_xviii"></a></em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Chief.vue?5760b97e